export const refs = {
  wellcomeText: document.querySelector('.welcome-message'),
  nameInput: document.querySelector('.user-name'),
};
